import AuthorizedElement from './AuthorizedElement';

export default AuthorizedElement;
